import { render, staticRenderFns } from "./toc_v1.vue?vue&type=template&id=04635cfe&scoped=true&lang=pug&"
import script from "./toc_v1.vue?vue&type=script&lang=js&"
export * from "./toc_v1.vue?vue&type=script&lang=js&"
import style0 from "./toc_v1.vue?vue&type=style&index=0&id=04635cfe&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04635cfe",
  null
  
)

export default component.exports